import React, { useState, useEffect } from 'react'
import {
  TextDemo,
  TextWrap,
  TextWrap_CXL,
  TextWrap_XLVB,
  TextWrapIncoming,
  TextWrapIncomingUnread,
  TextWrapRead,
  TextWrapUnread,
  TextWrapUnread_CXL,
  TextWrapUnread_XLVB,
  trimOverlengthString,
} from '../Common/CellText'
import authenticationStore from '../../stores/authenticationStore'
import { INTERNAL_DOCUMENT_INCOMING_STATUS } from '../../constants'

const UnreadText = props => {
  const { currentUser, isCheckVTXL } = authenticationStore

  const [isVTXL, setVTXL] = useState(null)

  useEffect(() => {
    const fetchCurrentUser = async () => {
      const checkVTXL = await authenticationStore.isCheckVTXL
      setVTXL(checkVTXL)
    }

    fetchCurrentUser()
  }, [])

  if (isVTXL === null) {
    return <div></div>
  }

  if (isVTXL === true) {
    if (props.isUnread) {
      if (
        props.isButPhe === INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING &&
        props.isXLVB === null
      ) {
        return (
          <TextWrapUnread_CXL>
            {trimOverlengthString(props.text, props.width)}
          </TextWrapUnread_CXL>
        )
      } else if (
        props.isButPhe === INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING &&
        props.isXLVB !== null
      ) {
        return (
          <TextWrapUnread_CXL>
            {trimOverlengthString(props.text, props.width)}
          </TextWrapUnread_CXL>
        )
      } else if (
        props.isButPhe === INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS &&
        props.isXLVB === null
      ) {
        return (
          <TextWrapIncomingUnread>
            {trimOverlengthString(props.text, props.width)}
          </TextWrapIncomingUnread>
        )
      } else if (
        props.isButPhe === INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS &&
        props.isXLVB !== null
      ) {
        return (
          <TextWrapIncomingUnread>
            {trimOverlengthString(props.text, props.width)}
          </TextWrapIncomingUnread>
        )
      } else if (
        props.isButPhe !== INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING &&
        props.isButPhe !== INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS &&
        props.isXLVB === null
      ) {
        return (
          <TextWrapIncomingUnread>
            {trimOverlengthString(props.text, props.width)}
          </TextWrapIncomingUnread>
        )
      } else {
        return (
          <TextWrapIncomingUnread>
            {trimOverlengthString(props.text, props.width)}
          </TextWrapIncomingUnread>
        )
      }
    } else {
      if (
        props.isButPhe === INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING &&
        props.isXLVB === null
      ) {
        return (
          <TextWrap_CXL>
            {trimOverlengthString(props.text, props.width)}
          </TextWrap_CXL>
        )
      } else if (
        props.isButPhe === INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING &&
        props.isXLVB !== null
      ) {
        return (
          <TextWrap_CXL>
            {trimOverlengthString(props.text, props.width)}
          </TextWrap_CXL>
        )
      } else if (
        props.isButPhe === INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS &&
        props.isXLVB === null
      ) {
        return (
          <TextWrap_XLVB>
            {trimOverlengthString(props.text, props.width)}
          </TextWrap_XLVB>
        )
      } else if (
        props.isButPhe === INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS &&
        props.isXLVB !== null
      ) {
        return (
          <TextWrapIncoming>
            {trimOverlengthString(props.text, props.width)}
          </TextWrapIncoming>
        )
      } else if (
        props.isButPhe !== INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING &&
        props.isButPhe !== INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS &&
        props.isXLVB === null
      ) {
        return (
          <TextWrapIncoming>
            {trimOverlengthString(props.text, props.width)}
          </TextWrapIncoming>
        )
      } else {
        return (
          <TextWrapIncoming>
            {trimOverlengthString(props.text, props.width)}
          </TextWrapIncoming>
        )
      }
    }
  } else {
    if (props.isUnread) {
      return (
        <TextWrapRead>
          {trimOverlengthString(props.text, props.width)}
        </TextWrapRead>
      )
    } else {
      return (
        <TextWrapUnread>
          {trimOverlengthString(props.text, props.width)}
        </TextWrapUnread>
      )
    }
  }
}

export default UnreadText
